module.exports = __webpack_public_path__ + "img/logo1.77de693c.png";